import { Component } from '@angular/core';
import {
  AbstractBlModal,
  ModalSize,
  ModalButtonType,
  TableHeader,
} from '@blcloud/bl-ng-ui-component';
import {
  ITicketIssue
} from '@blcloud/bl-datamodel';
import {
  DateTimeOutput,
  DateTimeUtils,
  DateTimePadding,
  DateSeparator,
  DateEra,
} from '@blcloud/bl-common';
import { isNil as _isNil, map as _map, assign as _assign, cloneDeep as _cloneDeep, } from 'lodash';
import { ITicketIssueForTable } from './reference-ticket-modal.interface';

/**
 * クーポンの表示コンポーネント
 */
@Component({
  templateUrl: './reference-ticket-modal.component.html',
  styleUrls: ['./reference-ticket-modal.component.scss'],
})
export class ReferenceTicketModalComponent extends AbstractBlModal {

  /** データ */
  data: { ticketIssue: ITicketIssue[] };

  /** モーダルウィンドウボタンタイプ */
  readonly modalButtonType = ModalButtonType;

  /** テーブル：ヘッダ */
  headers: TableHeader[] = [
    { key: 'ticketCode', label: 'クーポンコード', width: '10%' },
    { key: 'ticketName', label: 'クーポン名称', width: '35%' },
    { key: 'ticketIssueDate', label: '発行日', width: '10%' },
    { key: 'applyDate', label: '有効期限', width: '10%' },
    { key: 'ticketRemarks', label: '説明', width: '35%' },
  ];

  /** データリスト */
  ticketIssueList: ITicketIssueForTable[] = [];

  /** 日付最小値 */
  private readonly minDateTime = DateTimeUtils.initial.iso8601.date;

  /** 日付最大値 */
  private readonly maxDateTime = '2999-12-31';

  /** 日付が無い時のラベル */
  private readonly NO_DATE_LABEL = 'なし';

  /**
   * コンストラクタ
   */
  constructor(
  ) {
    super();
  }

  // --------------------------------------------------
  // AbstractModal Override

  /**
   * @override
   */
  onShown() {
    const data = _cloneDeep(this.data);
    this.ticketIssueList = _map(data.ticketIssue, ticketIssue => {
      ticketIssue.ticketIssueDate = this.createAbridgementDateStr(ticketIssue.ticketIssueDate);
      return _assign(ticketIssue, {
        applyDate: this.createAbridgementApplyDateStr(ticketIssue)
      });
    });
  }

  /**
   * @override
   */
  getResults() {
    return;
  }

  /**
   * @override
   */
  defaultOption() {
    return {
      size: ModalSize.Full,
    };
  }

  /**
   * 有効期限の開始～終了省略文字列を作成する
   * @param ticketSetting クーポン設定
   * @returns 有効期限の文字列
   */
  createAbridgementApplyDateStr(ticketSetting: ITicketIssue): string {
    if (this.hasNoStartDate(ticketSetting.applyStartDate) && this.hasNoEndDate(ticketSetting.applyEndDate)) {
      return this.NO_DATE_LABEL;
    }
    const startDateResult = this.createAbridgementDateStr(ticketSetting.applyStartDate);
    const endDateResult = this.createAbridgementDateStr(ticketSetting.applyEndDate);
    if (_isNil(startDateResult) && _isNil(endDateResult)) {
      return this.NO_DATE_LABEL;
    }
    return startDateResult + '～' + endDateResult;
  }

  /**
   * 日付の省略文字列を作成する
   * @param date 日付文字列
   * @returns 省略文字列
   */
  createAbridgementDateStr(date: string): string {
    const dateNum = this.convertDateNum(date);
    if (_isNil(dateNum)) {
      return '';
    }
    const dateStr = DateTimeUtils.format(
      dateNum,
      DateTimeOutput.YMD,
      DateTimePadding.ZERO,
      DateSeparator.DOT,
      DateEra.SHORT_JP
    );
    if (_isNil(dateStr)) {
      return '';
    }
    return dateStr;
  }

  /**
   * 日付文字列を数値へ変換する
   * @param date 日付
   * @returns 日付数値
   */
  private convertDateNum(date: string): number {
    if (_isNil(date)) {
      return null;
    }
    const dateNumStr = date.split('-').join('');
    const dateNumFormat = /^[0-9]{8}$/;
    if (!dateNumFormat.test(dateNumStr)) {
      return null;
    }
    return parseInt(dateNumStr, 10);
  }

  /**
   * 開始日付の存在を判定する
   * @param date 日付
   * @returns 判定結果
   */
  private hasNoStartDate(date: string): boolean {
    return _isNil(date) || date === this.minDateTime;
  }

  /**
   * 終了日付の存在を判定する
   * @param date 日付
   * @returns 判定結果
   */
  private hasNoEndDate(date: string): boolean {
    return _isNil(date) || date === this.maxDateTime;
  }
}



// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/reference-ticket-modal/reference-ticket-modal.component.ts